import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "../lib/motion";
import { SOLUTIONS } from "../data";

const SOL_IMG =
  "https://images.unsplash.com/photo-1677442135131-4d7c123aef1c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwzfHxhcnRpZmljaWFsJTIwaW50ZWxsaWdlbmNlJTIwbmV1cmFsJTIwbmV0d29yayUyMGFic3RyYWN0fGVufDB8fHx8MTc4NTQzOTQ5OHww&ixlib=rb-4.1.0&q=85";

export const Solutions = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "12%"]);

  return (
    <section
      id="solutions"
      ref={ref}
      className="relative overflow-hidden border-t border-black/10 bg-[#f4f4f1] py-28 md:py-36"
      data-testid="solutions-section"
    >
      <div className="container-vx grid grid-cols-1 items-center gap-16 lg:grid-cols-2">
        <div>
          <Reveal>
            <span className="label-mono">/ Solutions by industry</span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 max-w-xl font-sans text-4xl font-light leading-tight tracking-tight md:text-5xl">
              Built for the operations that run the physical and digital world.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 max-w-lg font-body text-neutral-600">
              We embed autonomy where the stakes are highest — regulated,
              real-time and mission-critical environments.
            </p>
          </Reveal>

          <div className="mt-12 grid grid-cols-1 overflow-hidden rounded-2xl border border-black/10 bg-white sm:grid-cols-2">
            {SOLUTIONS.map((s, i) => {
              const Icon = s.icon;
              return (
                <Reveal key={s.name} delay={i * 0.06}>
                  <div
                    className="group flex items-center gap-4 border-b border-r border-black/10 p-6 transition-colors duration-400 hover:bg-black/[0.03]"
                    data-testid={`solution-${i}`}
                  >
                    <Icon
                      className="h-5 w-5 text-neutral-500 transition-colors duration-400 group-hover:text-[var(--accent)]"
                      strokeWidth={1.5}
                    />
                    <span className="font-body font-medium text-neutral-800">
                      {s.name}
                    </span>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>

        <Reveal delay={0.15}>
          <div className="spotlight-img relative aspect-[4/5] overflow-hidden rounded-3xl border border-black/10 card-shadow">
            <motion.img
              style={{ y }}
              src={SOL_IMG}
              alt="AI neural chip visualization"
              className="h-[120%] w-full object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <div className="glass inline-flex items-center gap-3 rounded-full border border-black/10 px-5 py-3">
                <span className="h-2 w-2 animate-pulse rounded-full bg-[var(--accent)]" />
                <span className="font-mono text-xs uppercase tracking-widest text-neutral-800">
                  System online · 42M decisions today
                </span>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
